import { forwardRef, useCallback } from "react";

import { menuTypographyProps } from "NavBar/components/NavLink";
import SettingsOptionWrapper from "NavBar/components/settings/SettingsOptionWrapper";
import { menuIconProps } from "NavBar/styleConstants";

import FnrShineButton from "UI/FnrButton3/FnrShineButton";
import FnrContainedIcon from "UI/FnrContainedIcon";
import FnrTypography from "UI/FnrTypography";

import externalNavigate from "Utilities/externalNavigate";

const LogInToAnotherAccount = forwardRef((props, ref) => {
  const handleClick = useCallback(() => {
    const url = `https://${window.location.hostname.replace(
      /^.*?\./,
      "login."
    )}/login?forceLoginPage=true`;
    externalNavigate(url, "_self");
  }, []);

  return (
    <FnrShineButton
      borderRadius={8}
      data-cy="NavBar_LogInToAnotherAccount"
      onClick={handleClick}
      ref={ref}
      {...props}
    >
      <SettingsOptionWrapper>
        <FnrContainedIcon {...menuIconProps} icon="sign-in fas" />
        <FnrTypography {...menuTypographyProps}>
          Log in to another account
        </FnrTypography>
      </SettingsOptionWrapper>
    </FnrShineButton>
  );
});

export default LogInToAnotherAccount;
